if (!customElements.get('media-gallery')) { 
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {

    constructor() {
      super();
      this.slider = this.querySelector('[id="images-slider"]');
      this.thumbnails = this.querySelector('.thumbnails-slider');
      this.dots = this.querySelector('[id^="GalleryThumbnails-dots"]');
      this.only_mobile_dots = this.querySelector('[data-mobile-thumbs]');
            

      if(!this.slider) return

      
      this.is_slider = this.slider.getAttribute("data-desktop-type") === "slider";
      this._selected = this.slider.querySelector('[data-selected]');
      this.autoheight = this.dataset.autoheight === "true";
      this.isLargeScreen = window.innerWidth > 850;      


      // Set initial selected
      this.handleSelected();




      document.addEventListener('DOMContentLoaded', () => this.updateThumbnailsHeight());
      window.addEventListener('resize', () => this.updateThumbnailsHeight());

      const debouncedResize = debounce(this.handleSelected.bind(this), 250);
      window.addEventListener('resize', debouncedResize);



      if ('onscrollend' in window) {
        this.slider.addEventListener('scrollend', () => this.handleSelected());
      } else {
        let timer;
        this.slider.addEventListener('scroll', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.handleSelected(), 250);
        });
      }



      [...this.querySelectorAll('.thumbnail')].forEach(thumbnail=>{
        thumbnail.addEventListener('click', ()=>{
          this.updateThumbnail(thumbnail.getAttribute('data-skip'))
          this.sliderScroll(thumbnail.getAttribute('data-skip'))
        })
      })

      if (!this.thumbnails) return;      
      this.isVertical = this.thumbnails.getAttribute('data-inline') === "true";

    }


    restoreDiazzaMediaOrder() {
      if (!this.slider) return;

      [...this.slider.children]
        .filter((item) => item.dataset.image)
        .sort((a, b) => Number(a.dataset.image) - Number(b.dataset.image))
        .forEach((item) => {
          item.hidden = false;
          item.style.removeProperty('order');
          item.style.removeProperty('display');
          item.removeAttribute('aria-hidden');
          this.slider.appendChild(item);
        });

      this.querySelectorAll('.product_thumbnails').forEach((container) => {
        [...container.children]
          .filter((item) => item.classList.contains('thumbnail') && item.dataset.skip)
          .sort((a, b) => Number(a.dataset.skip) - Number(b.dataset.skip))
          .forEach((item) => {
            item.hidden = false;
            item.style.removeProperty('order');
            item.style.removeProperty('display');
            item.removeAttribute('aria-hidden');
            container.appendChild(item);
          });
      });
    }

    resetVariantMediaFilter() {
      this.diazzaApplyingVariant = false;
      this.restoreDiazzaMediaOrder();
      this.dataset.diazzaVariantGallery = 'false';
      this.handleSelected();
      this.updateThumbnailsHeight();
    }

    diazzaMediaNumber(mediaId) {
      return String(mediaId || '').split('-').pop();
    }

    diazzaCosineSimilarity(a, b) {
      if (!a || !b || a.length !== b.length) return 0;
      let dot = 0;
      for (let i = 0; i < a.length; i += 1) dot += a[i] * b[i];
      return dot;
    }

    diazzaImageSourceKey(slide) {
      const image = slide?.querySelector('img');
      const source = image?.currentSrc || image?.src || '';
      if (!source) return '';
      try {
        const url = new URL(source, window.location.origin);
        url.search = '';
        return url.pathname
          .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '')
          .toLowerCase();
      } catch (error) {
        return source.split('?')[0].toLowerCase();
      }
    }

    async diazzaImageFeature(image) {
      if (!image) return null;
      try {
        image.loading = 'eager';
        await image.decode();
        const canvas = document.createElement('canvas');
        const size = 40;
        canvas.width = size;
        canvas.height = size;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, size, size);
        const pixels = context.getImageData(0, 0, size, size).data;
        const feature = new Array(48).fill(0);

        for (let y = 0; y < size; y += 1) {
          for (let x = 0; x < size; x += 1) {
            const offset = (y * size + x) * 4;
            if (pixels[offset + 3] < 180) continue;
            const r = pixels[offset] / 255;
            const g = pixels[offset + 1] / 255;
            const b = pixels[offset + 2] / 255;
            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            const delta = max - min;
            const saturation = max === 0 ? 0 : delta / max;
            const value = max;
            if (saturation < 0.12 || value < 0.12 || value > 0.98) continue;

            let hue = 0;
            if (delta !== 0) {
              if (max === r) hue = ((g - b) / delta) % 6;
              else if (max === g) hue = ((b - r) / delta) + 2;
              else hue = ((r - g) / delta) + 4;
              hue = (hue * 60 + 360) % 360;
            }

            const dx = (x - size / 2) / (size / 2);
            const dy = (y - size / 2) / (size / 2);
            const centerWeight = 1 + Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy)) * 0.5;
            const weight = centerWeight * (0.25 + 2.25 * saturation * saturation);
            feature[Math.min(31, Math.floor(hue / 11.25))] += weight;
            feature[32 + Math.min(7, Math.floor(saturation * 8))] += weight * 0.22;
            feature[40 + Math.min(7, Math.floor(value * 8))] += weight * 0.18;
          }
        }

        const magnitude = Math.sqrt(feature.reduce((sum, value) => sum + value * value, 0));
        if (!magnitude) return null;
        return feature.map((value) => value / magnitude);
      } catch (error) {
        return null;
      }
    }

    async buildDiazzaVisualMediaGroups(productInfoNode) {
      if (this.diazzaVisualGroups || this.diazzaVisualGroupsPromise) return this.diazzaVisualGroupsPromise;
      const colorFieldset = productInfoNode.querySelector('fieldset[data-diazza-color-option="true"]');
      const controls = [...(colorFieldset?.querySelectorAll('[data-diazza-featured-media-id]') || [])]
        .filter((control) => control.dataset.diazzaFeaturedMediaId);
      const anchors = [...new Map(controls.map((control) => [control.dataset.diazzaFeaturedMediaId, control])).entries()];
      if (anchors.length < 2) return null;

      const slides = [...this.slider.children].filter((item) => item.dataset.mediaId && item.querySelector('img'));
      const cacheKey = `diazza-media-groups-v2:${location.pathname}:${slides.length}:${anchors.map(([id]) => id).join('-')}`;
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        if (cached) {
          this.diazzaVisualGroups = cached;
          return cached;
        }
      } catch (error) {}

      this.diazzaVisualGroupsPromise = (async () => {
        const features = new Map();
        for (const slide of slides) {
          const feature = await this.diazzaImageFeature(slide.querySelector('img'));
          if (feature) features.set(this.diazzaMediaNumber(slide.dataset.mediaId), feature);
        }

        const anchorFeatures = anchors
          .map(([mediaId]) => [mediaId, features.get(mediaId)])
          .filter(([, feature]) => feature);
        if (anchorFeatures.length < 2) return null;

        const groups = Object.fromEntries(anchors.map(([mediaId]) => [mediaId, [{ mediaId, score: 2 }]]));
        for (const slide of slides) {
          const mediaId = this.diazzaMediaNumber(slide.dataset.mediaId);
          if (groups[mediaId]) continue;
          const feature = features.get(mediaId);
          if (!feature) continue;

          const scores = anchorFeatures
            .map(([anchorId, anchorFeature]) => ({ anchorId, score: this.diazzaCosineSimilarity(feature, anchorFeature) }))
            .sort((a, b) => b.score - a.score);
          const best = scores[0];
          const second = scores[1];
          if (!best || !second || best.score < 0.72 || best.score - second.score < 0.025) continue;
          groups[best.anchorId].push({ mediaId, score: best.score });
        }

        const compact = {};
        Object.entries(groups).forEach(([anchorId, items]) => {
          const ranked = items.sort((a, b) => b.score - a.score);
          const kept = [];
          for (const item of ranked) {
            if (kept.length >= 5) break;
            const feature = features.get(item.mediaId);
            const isDuplicate = kept.some((keptItem) => {
              const keptFeature = features.get(keptItem.mediaId);
              return feature && keptFeature && this.diazzaCosineSimilarity(feature, keptFeature) > 0.985;
            });
            if (!isDuplicate) kept.push(item);
          }
          compact[anchorId] = kept.map((item) => item.mediaId);
        });
        this.diazzaVisualGroups = compact;
        try { sessionStorage.setItem(cacheKey, JSON.stringify(compact)); } catch (error) {}
        return compact;
      })().finally(() => {
        this.diazzaVisualGroupsPromise = null;
      });

      const result = await this.diazzaVisualGroupsPromise;
      if (result && this.diazzaLastProductInfo && this.diazzaLastVariant) {
        this.applyVariantMedia(this.diazzaLastProductInfo, this.diazzaLastVariant);
      }
      return result;
    }

    applyVariantMedia(productInfoNode, variant) {
      if (!this.slider || !productInfoNode) {
        this.resetVariantMediaFilter();
        return false;
      }

      const colorFieldset = productInfoNode.querySelector('fieldset[data-diazza-color-option="true"]');
      if (!colorFieldset) {
        this.resetVariantMediaFilter();
        return false;
      }

      const selectedColorControl = colorFieldset.querySelector('input:checked, option:checked');
      const selectedColorMediaId = selectedColorControl?.dataset?.diazzaFeaturedMediaId || '';
      const secondaryFieldset = [...productInfoNode.querySelectorAll('fieldset[data-diazza-option-position]')]
        .find((fieldset) => fieldset.dataset.diazzaColorOption !== 'true');

      let mediaIds = [];
      if (secondaryFieldset) {
        mediaIds = [...secondaryFieldset.querySelectorAll('[data-diazza-featured-media-id]')]
          .map((item) => item.dataset.diazzaFeaturedMediaId)
          .filter(Boolean);
      }

      if (!mediaIds.length && selectedColorMediaId) {
        mediaIds = [selectedColorMediaId];
      }

      let uniqueMediaIds = [...new Set(mediaIds)];
      if (!uniqueMediaIds.length) {
        if (this.dataset.diazzaVariantGallery === 'grouped' || this.dataset.diazzaVariantGallery === 'single') {
          return true;
        }
        this.resetVariantMediaFilter();
        return false;
      }

      const selectionRevision = (this.diazzaSelectionRevision || 0) + 1;
      this.diazzaSelectionRevision = selectionRevision;
      this.diazzaApplyingVariant = true;
      const previouslySelectedMediaId = this.selected?.dataset?.mediaId || '';

      this.diazzaLastProductInfo = productInfoNode;
      this.diazzaLastVariant = variant;
      if (uniqueMediaIds.length === 1 && selectedColorMediaId) {
        const visualGroup = this.diazzaVisualGroups?.[selectedColorMediaId];
        if (visualGroup?.length > 1) uniqueMediaIds = visualGroup;
        else if (!this.diazzaVisualGroupsPromise) this.buildDiazzaVisualMediaGroups(productInfoNode);
      }

      this.restoreDiazzaMediaOrder();

      const sectionId = this.id.replace('MediaGallery-', '');
      const allowedMediaIds = new Set(uniqueMediaIds.map((mediaId) => `${sectionId}-${mediaId}`));
      const preferredMediaId = variant?.featured_media?.id || selectedColorMediaId || uniqueMediaIds[0];
      const selectedMediaId = `${sectionId}-${preferredMediaId}`;
      const slides = [...this.slider.children].filter((item) => item.dataset.mediaId);
      const candidateSlides = slides.filter((item) => allowedMediaIds.has(item.dataset.mediaId));
      const variantHasFeaturedMedia = Boolean(variant?.featured_media?.id);
      const preferredCandidate = variantHasFeaturedMedia
        ? candidateSlides.find((item) => item.dataset.mediaId === selectedMediaId)
        : null;
      const candidatesForDeduplication = preferredCandidate
        ? [preferredCandidate, ...candidateSlides.filter((item) => item !== preferredCandidate)]
        : candidateSlides;
      const seenSources = new Set();
      const visibleSlides = candidatesForDeduplication.filter((item) => {
        const sourceKey = this.diazzaImageSourceKey(item);
        if (!sourceKey) return true;
        if (seenSources.has(sourceKey)) return false;
        seenSources.add(sourceKey);
        return true;
      });

      // Diazza: keep videos, external videos and 3D media for every variant.
      // Color-specific filtering continues to apply to product images only.
      const supplementalMedia = slides.filter((item) =>
        item.dataset.type && item.dataset.type !== 'image'
      );
      supplementalMedia.forEach((item) => {
        if (!visibleSlides.includes(item)) visibleSlides.push(item);
      });

      if (!visibleSlides.length) {
        this.resetVariantMediaFilter();
        return false;
      }

      const exactVariantSlide = variantHasFeaturedMedia
        ? visibleSlides.find((item) => item.dataset.mediaId === selectedMediaId)
        : null;
      const previousValidSlide = !variantHasFeaturedMedia
        ? visibleSlides.find((item) => item.dataset.mediaId === previouslySelectedMediaId)
        : null;
      const selectedSlide = exactVariantSlide || previousValidSlide || visibleSlides[0];
      const visibleSlideSet = new Set(visibleSlides);
      const orderedSlides = [
        selectedSlide,
        ...visibleSlides.filter((item) => item !== selectedSlide),
        ...slides.filter((item) => !visibleSlideSet.has(item))
      ];

      orderedSlides.forEach((item) => {
        const isVisible = visibleSlideSet.has(item);
        item.hidden = !isVisible;
        item.toggleAttribute('aria-hidden', !isVisible);
        if (isVisible) item.style.removeProperty('display');
        else item.style.setProperty('display', 'none', 'important');
        this.slider.appendChild(item);
      });

      this.querySelectorAll('.product_thumbnails').forEach((container) => {
        const thumbnails = [...container.children].filter((item) => item.classList.contains('thumbnail') && item.dataset.skip);
        const selectedSkip = selectedSlide.dataset.image;
        const visibleThumbs = thumbnails.filter((thumbnail) => {
          const slide = slides.find((item) => item.dataset.image === thumbnail.dataset.skip);
          return slide && visibleSlideSet.has(slide);
        });
        const selectedThumb = visibleThumbs.find((thumbnail) => thumbnail.dataset.skip === selectedSkip);
        const orderedThumbs = [
          ...(selectedThumb ? [selectedThumb] : []),
          ...visibleThumbs.filter((thumbnail) => thumbnail !== selectedThumb),
          ...thumbnails.filter((thumbnail) => !visibleThumbs.includes(thumbnail))
        ];

        const visibleThumbSet = new Set(visibleThumbs);
        orderedThumbs.forEach((thumbnail) => {
          const isVisible = visibleThumbSet.has(thumbnail);
          thumbnail.hidden = !isVisible;
          thumbnail.toggleAttribute('aria-hidden', !isVisible);
          if (isVisible) thumbnail.style.removeProperty('display');
          else thumbnail.style.setProperty('display', 'none', 'important');
          container.appendChild(thumbnail);
        });
      });

      this.dataset.diazzaVariantGallery = visibleSlides.length > 1 ? 'grouped' : 'single';
      this.updateSelected(selectedSlide);
      this.updateThumbnail(selectedSlide.dataset.image);

      if (window.innerWidth < 850) {
        this.slider.scrollTo({ left: 0, behavior: 'auto' });
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this.diazzaSelectionRevision !== selectionRevision) return;
            this.slider.scrollTo({ left: 0, behavior: 'auto' });
            this.updateSelected(selectedSlide);
            this.updateThumbnail(selectedSlide.dataset.image);
            this.diazzaApplyingVariant = false;
          });
        });
      } else {
        this.slider.scrollLeft = 0;
        requestAnimationFrame(() => {
          if (this.diazzaSelectionRevision !== selectionRevision) return;
          this.sliderScroll(selectedSlide.dataset.image);
          this.updateSelected(selectedSlide);
          this.updateThumbnail(selectedSlide.dataset.image);
          this.diazzaApplyingVariant = false;
        });
      }

      this.handleHeight();
      this.updateThumbnailsHeight();
      return true;
    }

    handleResize() {
      this.handleHeight()
    }


    onSelectedChange(newValue) {  
      this.slider.dispatchEvent(new CustomEvent('selected:change', {
        detail: { selected: newValue }
      }));
      
    }

    handleSelected(){
        if (this.diazzaApplyingVariant) return;
        
        const sliderRect = this.slider.getBoundingClientRect();
        const sliderCenter = sliderRect.left + sliderRect.width / 2;

        let closestItem = null;
        let minDistance = Infinity;

        [...this.slider.children].forEach((item) => {
          if (!item.dataset.image || item.hidden) return; // Skip hidden or non-media items

          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(sliderCenter - itemCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closestItem = item;
          }
        });


        if (closestItem) {
          if (this.thumbnails) {
            this.updateThumbnail(closestItem.getAttribute('data-image') * 1);
          }
          // 🔹 Use the unified update method so event & logic stay consistent
          this.updateSelected(closestItem);
          if (this.autoheight) {
            //this.updateHeight(1 * this.selected.dataset.height, 1 * this.selected.dataset.width);
            this.handleHeight(closestItem)
          }
          

          // Optionally: auto height adjustment or any follow-up logic
          /* if (this.autoheight && (this.is_slider || window.innerWidth <= 850)) {
            this.handleHeight();
          } */
        }

    }

    scrollToImage(selected){
          if (this.is_slider || window.innerWidth < 850) {
            const slider_x_start = this.slider.getBoundingClientRect().left;
            const selected_x = selected.getBoundingClientRect().left;
            const offset = selected_x - slider_x_start;
        
            this.slider.scrollTo({
            left: this.slider.scrollLeft + offset,
            behavior: 'instant' // 'auto' or remove this line if 'instant' doesn't work well
            });
        } else {
            const element_rect = selected.getBoundingClientRect();
            const scroll_target = window.scrollY + element_rect.top - (window.innerHeight / 2) + (element_rect.height / 2);
        
            window.scrollTo({
            top: scroll_target,
            behavior: "smooth"
            });
        }
    }

    sliderScroll(index){              
          const selected_element = this.slider.querySelector(`[data-image='${index}']`);
          if (!selected_element) return;

          this.scrollToImage(selected_element);

    }

    updateSelected(newElement) {
      if (!newElement) return;
      if (this.selected) this.selected.removeAttribute('data-selected');
      newElement.setAttribute('data-selected', 'true');
      this.selected = newElement; // triggers setter and onSelectedChange()
    }

    updateThumbnail(index) {
      if (!this.thumbnails || index === undefined) return;
    
      
      const thumbnails = this.thumbnails.querySelectorAll('.thumbnail');

      thumbnails.forEach(thumbnail => {
        if (thumbnail.getAttribute('data-skip') * 1 === index * 1) {
          thumbnail.classList.add('active');
          if (thumbnail.classList.contains('thumbnail_image')) {
            this.thumbnailScrollImages(thumbnail)
          }
        } else {
          thumbnail.classList.remove('active');
        }
      });
    }

    thumbnailScrollImages(thumbnail){
          const container = thumbnail.closest('.product_thumbnails')
          const containerRect = container.getBoundingClientRect();
          
          const thumbnailRect = thumbnail.getBoundingClientRect();          
    
          if (this.isVertical && this.isLargeScreen) {
            // Scroll Vertically if in vertical mode and screen is large
            const containerScrollTop = container.scrollTop;
            const scrollTo = containerScrollTop + (thumbnailRect.top + thumbnailRect.height / 2) - 
                             (containerRect.top + containerRect.height / 2);
            container.scrollTo({ top: scrollTo, behavior: 'smooth' });
          } else {

            
            // Scroll Horizontally (default for small screens or horizontal mode)
            const containerScrollLeft = container.scrollLeft;
            const scrollTo = containerScrollLeft + (thumbnailRect.left + thumbnailRect.width / 2) - 
                             (containerRect.left + containerRect.width / 2);
            container.scrollTo({ left: scrollTo, behavior: 'smooth' });
          }
    }

    updateThumbnailsHeight() {
      
      if (!this.slider || !this.thumbnails) return;
       
        const thumbnail_images = this.thumbnails.querySelector('#GalleryThumbnails-images')


        if (thumbnail_images) {
          const isVertical = this.thumbnails.getAttribute('data-inline') === "true";
          const isLargeScreen = window.innerWidth > 850;
        
          if (!isVertical || !isLargeScreen) {
            // Reset height if it's horizontal or on a small screen
            thumbnail_images.style.maxHeight = "";
            return;
          }
        
          const sliderHeight = this.slider.clientHeight;
          thumbnail_images.style.maxHeight = `${sliderHeight}px`;
        }
    
      
    }

    handleHeight(){
 
      if (this.is_slider || window.innerWidth < 850) {        
        if (this.autoheight && this.selected) {
          return  this.slider.style.height = `${ this.selected.offsetWidth * this.selected.dataset.height / this.selected.dataset.width }px`;
        }else {
          return  this.slider.style.height = "auto" 
        }
        
      }else{
        return  this.slider.style.height = "auto"
      }
    }

    get selected() {
      return this._selected;
    }

    set selected(newValue) {                  
      if (this._selected !== newValue) {
        this._selected = newValue;
        this.onSelectedChange(newValue);
      }
    }

  });
}